import { injectable } from "inversify";
import { Message, Field, Type } from "protobufjs/light";
import { Result, ok } from "@xlearn/common";
import * as Api from "@/app/state-serialization/api";
import { ScenarioAnswer, ScenarioScores } from "./scenario-interfaces";
import { ProtobufSerializer } from "@/app/state-serialization/infrastructure";

interface ScenarioScoreItem {
  nodeId: string;
  score: number;
}

@injectable()
export class ScenarioQuestionAnswerProtobufSerializer
  implements Api.StateSerializationPlugin<ScenarioAnswer> {
  key = {
    id: 21,
    name: { ns: "suspend-data", name: "question-answer-scenario" },
    format: "protobuf"
  };

  serialize(data: ScenarioAnswer): Result<Uint8Array, Api.SerializerError> {
    const scoreByNodeId = [];

    for (const nodeId in data.scoreByNodeId) {
      scoreByNodeId.push({
        nodeId,
        score: data.scoreByNodeId[nodeId],
      })
    }

    const message = new ScenarioAnswerProtoMessage({
      currentNodeId: data.currentNodeId,
      scoreByNodeId,
    });

    return ProtobufSerializer.serialize<ScenarioAnswerProtoMessage>(
      message,
      ScenarioAnswerProtoMessage
    );
  }

  deserialize(
    content: Uint8Array
  ): Result<ScenarioAnswer, Api.DeserializerError> {
    const deserializeResult = ProtobufSerializer.deserialize<
      ScenarioAnswerProtoMessage
    >(content, ScenarioAnswerProtoMessage);
    if (!deserializeResult.success) {
      return deserializeResult;
    }

    const scoreByNodeId: ScenarioScores = {};
    const message = deserializeResult.value;
    message.scoreByNodeId.forEach(score => scoreByNodeId[score.nodeId] = score.score);

    const result: ScenarioAnswer = {
      currentNodeId: message.currentNodeId,
      scoreByNodeId,
    };

    return ok(result);
  }
}

@Type.d("ScenarioScoreProtoMessage")
class ScenarioScoreProtoMessage extends Message<ScenarioScoreProtoMessage> {
  @Field.d(1, "string", "optional", "")
  nodeId: string;
  
  @Field.d(2, "uint32", "optional", 0)
  score: number;
}

@Type.d("ScenarioAnswerProtoMessage")
class ScenarioAnswerProtoMessage extends Message<ScenarioAnswerProtoMessage> {
  @Field.d(1, "string", "optional", "")
  currentNodeId: string;

  @Field.d(2, ScenarioScoreProtoMessage, "repeated")
  scoreByNodeId: ScenarioScoreItem[];
}
